import React from "react";
import { useEffect } from "react";
import Loader from "./Loader";

const states = {
    INIT: 1,
    UPDATING: 2,
    UPDATED: 3,
};

const Comp = ({ session, id, onSuccess }) => {

    const [viewState, setViewState] = React.useState(states.INIT);

    const printState = (state) => {
        const foundKey = Object.keys(states).find((k) => {
            return states[k] === state;
        });
        return foundKey;
    }

    const installIt = (id) => {
        console.log(`Installing ${id}`);
        session.call("installPackage.dappmanager.dnp.dappnode.eth", [], {
            id: id,
            options: {},
            userSetEnvs: {},
            userSetPorts: {},
            userSetVols: {}
        }).then(res => {
            transitionTo(states.UPDATED);
            onSuccess(id);
        }).catch((e) => {
            transitionTo(states.UPDATED);
            onSuccess(id);
        });
    }

    useEffect(() => {
        if (id) {
            setViewState(states.UPDATING);
            installIt(id);
        }
    }, [id]);

    const transitionTo = (newState) => {
        console.log(`going from state  ${printState(viewState)} to ${printState(newState)}`);
        if (viewState === newState) {
            console.log(`from and to state are the same`);
            return;
        }
        switch (newState) {
            case states.UPDATED:
                if ([states.UPDATING].includes(viewState)) {
                    setViewState(newState);
                }
                break;
            default:
                console.log("unknown target state");
        }
    }

    if (id && viewState === states.UPDATING) {
        const name = id.split(".")[0];
        return (<div>Updating package <b>{name}</b>&nbsp;<Loader /></div>);
    }

    return null;

}

export default Comp;
